import { FC } from 'react';
import classNames from 'classnames';
import { FormattedMessage } from 'dibs-react-intl';
import { Button } from 'dibs-elements/exports/Button';
import styles from './styles/ImageUploaderImageRenderer.scss';

type DeleteConfirmationProps = {
    imageClasses: string;
    onConfirmDelete: () => void;
    onHideDeleteConfirmation: () => void;
    segmentedView: boolean;
};

export const DeleteConfirmation: FC<DeleteConfirmationProps> = props => {
    const { imageClasses, onConfirmDelete, onHideDeleteConfirmation, segmentedView } = props;
    const deleteClass = classNames(styles.deleteConfirmationContainer, imageClasses);

    const titleCopy = (
        <FormattedMessage
            id="dibs-media-uploader.DeleteConfirmation.deleteImage"
            defaultMessage="Delete Image?"
        />
    );

    const deleteCopy = (
        <FormattedMessage
            id="dibs-media-uploader.DeleteConfirmation.delete"
            defaultMessage="Delete"
        />
    );

    const cancelCopy = (
        <FormattedMessage
            id="dibs-media-uploader.DeleteConfirmation.cancel"
            defaultMessage="Cancel"
        />
    );

    return (
        <div className={deleteClass}>
            {!segmentedView && (
                <>
                    <p className={styles.deleteConfirmationText}>{titleCopy}</p>
                    <div
                        data-tn="delete-image-confirm"
                        className={styles.confirmDelete}
                        onClick={onConfirmDelete}
                    >
                        {deleteCopy}
                    </div>

                    <div
                        data-tn="delete-image-cancel"
                        className={styles.cancelDelete}
                        onClick={onHideDeleteConfirmation}
                    >
                        {cancelCopy}
                    </div>
                </>
            )}
            {segmentedView && (
                <>
                    <p className={styles.deleteConfirmationTextLarge}>{titleCopy}</p>
                    <Button
                        dataTn="delete-image-confirm"
                        onClick={onConfirmDelete}
                        type="primary"
                        className={styles.confirmDeleteButton}
                    >
                        {deleteCopy}
                    </Button>
                    <Button
                        dataTn="delete-image-cancel"
                        onClick={onHideDeleteConfirmation}
                        type="secondary"
                        className={styles.cancelDeleteButton}
                    >
                        {cancelCopy}
                    </Button>
                </>
            )}
        </div>
    );
};
